import type { Collection, Folder } from '@/services/api'

/**
 * Recursively collect all subcollection IDs from a collection and its nested subcollections
 */
export function collectAllSubcollectionIds(subcollections: Collection[]): string[] {
  const ids: string[] = []
  
  for (const subcollection of subcollections) {
    if (subcollection.id) {
      ids.push(subcollection.id)
      
      // For now, we don't have deeply nested subcollections
      // If we add them in the future, we can recursively collect here
    }
  }
  
  return ids
}

/**
 * Recursively collect all folder IDs from a collection's folders and nested folders
 */
export function collectAllFolderIds(folders: Folder[]): string[] {
  const ids: string[] = []
  
  function collectFromFolder(folder: Folder, allFolders: Folder[]) {
    if (folder.id) {
      ids.push(folder.id)
      
      // Find subfolders (folders that have this folder as parent)
      const subfolders = allFolders.filter(f => f.parentFolderId === folder.id)
      for (const subfolder of subfolders) {
        collectFromFolder(subfolder, allFolders)
      }
    }
  }
  
  for (const folder of folders) {
    if (!folder.parentFolderId) {
      // Only start from root folders to avoid duplicates
      collectFromFolder(folder, folders)
    }
  }
  
  return ids
}

/**
 * Recursively collect all subfolder IDs from a folder
 */
export function collectAllSubfolderIds(subfolders: Folder[]): string[] {
  const ids: string[] = []
  
  function collectFromFolder(folder: Folder, allFolders: Folder[]) {
    if (folder.id) {
      ids.push(folder.id)
      
      // Find subfolders (folders that have this folder as parent)
      const nestedSubfolders = allFolders.filter(f => f.parentFolderId === folder.id)
      for (const subfolder of nestedSubfolders) {
        collectFromFolder(subfolder, allFolders)
      }
    }
  }
  
  for (const folder of subfolders) {
    collectFromFolder(folder, subfolders)
  }
  
  return ids
}